<template>
  <div
    class="flex flex-col w-full text-center justify-center items-center h-screen bg-slate-100 gap-4"
  >
    <p>{{ message }}</p>
    <a
      v-if="showFallback"
      :href="deepLink"
      class="px-4 py-2 bg-blue-500 text-white rounded"
    >
      Tap here to return to the app
    </a>
  </div>
</template>

<script>
export default {
  data() {
    return {
      message: "Redirecting to app...",
      showFallback: false,
      deepLink: "",
    };
  },
  mounted() {
    const reference = this.$route.query.reference;
    if (!reference) {
      console.warn("No reference in URL");
      this.message = "Missing payment reference.";
      return;
    }

    this.deepLink = `myapp://verify-payment?reference=${reference}`;

    // 1. Modern iPad check (Mimics Mac desktop but has multi-touch support)
    const isModerniPad =
      navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1;

    // 2. Comprehensive mobile check including Android, iOS, and modern iPads
    const isMobile =
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent,
      ) || isModerniPad;

    if (isMobile) {
      // For mobile devices, change the message and show the manual fallback button
      this.message = "Tap the button below to return to the app.";
      this.showFallback = true;

      // Optional: Try to auto-redirect them anyway, but they have the button as a backup
      window.location.href = this.deepLink;
    } else {
      // For desktop users, just try the redirect straight away
      window.location.href = this.deepLink;
    }
  },
};
</script>
